import React, { Fragment } from "react";
import PropTypes from "prop-types";
import JobTypeActiveContent from "./JobTypeActiveContent";
import {
  SectionTitle,
  Label,
  LabelText,
  RadioButtonsLabel,
  RadioButtonGroup,
  RadioButtonWrapper,
  RadioButton,
  RadioButtonLabel,
  Check,
  Field,
  Required,
  Error,
  Input,
  Select,
  Option,
} from "../styles/form-styles";

const JobDetails = ({
  jobTitle,
  location,
  sectorOptions,
  sector,
  salaryMin,
  salaryMax,
  handleTextInput,
  jobType,
  handleJobType,
  salaryType,
  handleSalaryType,
  currency,
  errors,
}) => (
  <Fragment>
    <SectionTitle>Job details</SectionTitle>
    <Field>
      <Label htmlFor="job-title" noMobile>
        <LabelText>
          Job Title <Required>*</Required>
        </LabelText>
      </Label>
      <Input
        mobileMargin
        type="text"
        name="jobTitle"
        id="job-title"
        placeholder="Job Title"
        value={jobTitle}
        onChange={(e) => handleTextInput(e)}
      />
      {errors.jobTitle && <Error jobTitle>{errors.jobTitle}</Error>}
    </Field>
    <Field>
      <Label htmlFor="location" noMobile>
        <LabelText>
          Location <Required>*</Required>
        </LabelText>
      </Label>
      <Input
        mobileMargin
        type="text"
        name="location"
        id="location"
        placeholder="Location"
        value={location}
        onChange={(e) => handleTextInput(e)}
      />
      {errors.location && <Error location>{errors.location}</Error>}
    </Field>
    <Field>
      <Label htmlFor="job-sector" noMobile>
        <LabelText>
          Sector <Required>*</Required>
        </LabelText>
      </Label>
      <Select
        id="job-sector"
        name="sector"
        title="sector"
        value={sector || ""}
        onChange={(e) => handleTextInput(e)}
      >
        <Option value="">Please select a sector...</Option>
        {sectorOptions.map((sectorOption) => (
          <Option key={sectorOption.id} value={sectorOption.id}>
            {sectorOption.label}
          </Option>
        ))}
      </Select>
      {errors.sector && <Error sector>{errors.sector}</Error>}
    </Field>
    <Field radioButtons>
      <RadioButtonsLabel>Job type:</RadioButtonsLabel>
      <RadioButtonGroup>
        <RadioButtonWrapper>
          <RadioButton
            name="jobType"
            id="permanent"
            type="radio"
            onChange={(e) => handleJobType(e)}
            checked={jobType === "permanent"}
          />
          <RadioButtonLabel htmlFor="permanent">Permanent</RadioButtonLabel>
          <Check />
        </RadioButtonWrapper>
        <RadioButtonWrapper>
          <RadioButton
            name="jobType"
            id="contract"
            type="radio"
            onChange={(e) => handleJobType(e)}
            checked={jobType === "contract"}
          />
          <RadioButtonLabel htmlFor="contract">Contract</RadioButtonLabel>
          <Check />
        </RadioButtonWrapper>
      </RadioButtonGroup>
    </Field>
    <JobTypeActiveContent
      jobType={jobType}
      salaryMin={salaryMin}
      salaryMax={salaryMax}
      handleTextInput={handleTextInput}
      salaryType={salaryType}
      handleSalaryType={handleSalaryType}
      currency={currency}
      errors={errors}
    />
  </Fragment>
);

JobDetails.propTypes = {
  salaryMin: PropTypes.string,
  salaryMax: PropTypes.string,
  handleTextInput: PropTypes.func.isRequired,
  salaryType: PropTypes.string.isRequired,
  handleSalaryType: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    title: PropTypes.string,
    location: PropTypes.string,
    sector_id: PropTypes.number,
    sector: PropTypes.string,
    jobTitle: PropTypes.string,
  }).isRequired,
  jobTitle: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  sectorOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  sector: PropTypes.string,
  jobType: PropTypes.string.isRequired,
  handleJobType: PropTypes.func.isRequired,
  currency: PropTypes.shape({
    symbol: PropTypes.string.isRequired,
    isoCode: PropTypes.string.isRequired,
  }),
};

JobDetails.defaultProps = {
  salaryMin: PropTypes.isNull,
  salaryMax: PropTypes.isNull,
  sector: PropTypes.isNull,
  currency: {
    symbol: null,
    isoCode: null,
  },
};

export default JobDetails;
